<template>
  <v-layout>
    <v-row style="max-width: 100%">
      <v-col
        cols="12"
        xs="12"
        md="4"
        v-show="
          Object.keys(itemListSelected).length === 0 ||
          this.$vuetify.breakpoint.mdAndUp
        "
      >
        <slot name="ladoIzquierdo"></slot>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        md="8"
        v-show="
          $vuetify.breakpoint.mdAndUp || Object.keys(itemListSelected).length
        "
        id="detalleTrabajo"
      >
        <slot name="ladoDerecho"></slot>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      itemListSelected: {},
      loading: 'bolsa-green',
      disabled: false,
      loadingDetail: false
    }
  }
}
</script>